const getMax = (x, y) => (x > y ? x : y)

export default getMax
